import styled from 'styled-components';

export const Container = styled.div`
  padding: 40px;
  max-width: 388px;
  width: 100%;
  border-radius: 20px;
  background: ${(props) => props.theme.colors.blueGray};
`;
